<template>
  <div class="campaign-form-container">
    <v-container>
      <v-layout row class="padding">
        <v-flex xs4 sm12 offset-sm3>
          <v-card
            class="mx-auto mt-4 pa-5 text-center text-no-wrap"
            max-width="1000"
            id="limited-products"
          >
            <div class="text-heading">
              <h2>Add Campaign</h2>
            </div>
            <v-card-text>
              <v-form v-model="valid" @submit.prevent lazy-validation>
                <v-container>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-select
                        v-model="campaignType"
                        :items="campaignTypes"
                        :error-messages="typeErrors"
                        label="Campaign Type"
                        @change="onChangeData"
                        @blur="$v.campaignType.$touch()"
                        :rules="[(v) => !!v || 'This field is required']"
                        outlined
                        dense
                        required
                      >
                      </v-select>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-select
                        v-model="campaignMode"
                        :items="campaignModes"
                        :error-messages="modeErrors"
                        label="Campaign Mode"
                        @change="$v.campaignMode.$touch()"
                        @blur="$v.campaignMode.$touch()"
                        outlined
                        dense
                        required
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row v-if="campaignMode == 'in_app'">
                    <v-col cols="12" md="12">
                      <v-text-field
                        v-model="in_app_title"
                        :rules="[(v) => !!v || 'This field is required']"
                        label="In App Title"
                        required
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-select
                        v-model="campaignTopic"
                        :items="campaignTopics"
                        :error-messages="topicErrors"
                        label="Campaign Topic"
                        :rules="[(v) => !!v || 'This field is required']"
                        @change="$v.campaignTopic.$touch()"
                        @blur="$v.campaignTopic.$touch()"
                        outlined
                        dense
                        required
                      >
                      </v-select>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-select
                        v-model="frequency"
                        :items="frequencies"
                        :error-messages="frequencyErrors"
                        label="Frequency"
                        :rules="[(v) => !!v || 'This field is required']"
                        outlined
                        dense
                        required
                        @change="$v.frequency.$touch()"
                        @blur="$v.frequency.$touch()"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row v-if="frequency == 'weekly'">
                    <v-col cols="12" md="12">
                      <v-select
                        v-model="week_day"
                        label="Week days"
                        :items="week_days"
                        outlined
                        dense
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row v-if="frequency == 'Alternative'">
                    <v-col cols="12" md="12">
                      <v-text-field
                        v-model="selected_days"
                        type="number"
                        :rules="[
                          (v) => !!v || 'This field is required',
                          (v) =>
                            /^\d$/.test(v) ||
                            'Field must be within 1 to 10 days',
                        ]"
                        label="Selected Days"
                        required
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="5">
                      <v-menu
                        ref="startmenu"
                        v-model="start"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="start_date"
                            label="Start date"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            required
                            outlined
                            dense
                            :error-messages="start_dateErrors"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="start_date"
                          :min="
                            new Date(
                              Date.now() -
                                new Date().getTimezoneOffset() * 60000
                            )
                              .toISOString()
                              .substr(0, 10)
                          "
                          max="new Date()"
                          @change="startDate"
                          @blur="$v.end_date.$touch()"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>

                    <v-col cols="12" md="5">
                      <v-menu
                        ref="endmenu"
                        v-model="end"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="end_date"
                            label="End date"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            required
                            outlined
                            dense
                            :error-messages="end_dateErrors"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="end_date"
                           :min="
                            new Date(
                              Date.now() -
                                new Date().getTimezoneOffset() * 60000
                            )
                              .toISOString()
                              .substr(0, 10)
                          "
                          max="new Date()"
                          @change="endDate"
                          @blur="$v.end_date.$touch()"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>

                    <v-col cols="12" md="2">
                      <v-text-field
                        v-model="campaign_time"
                        label="Campaign Time"
                        :error-messages="timeErrors"
                        :rules="[(v) => !!v || 'This field is required']"
                        @change="$v.campaign_time.$touch()"
                        @blur="$v.campaign_time.$touch()"
                        type="time"
                        outlined
                        dense
                        required
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="12">
                      <v-select
                        v-model="user_type"
                        :items="userType"
                        :error-messages="userErrors"
                        label="Users"
                        :rules="[(v) => !!v || 'This field is required']"
                        outlined
                        dense
                        required
                        @change="$v.user_type.$touch()"
                        @blur="$v.user_type.$touch()"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="campaignMode == 'email' || campaignMode == 'both'"
                  >
                    <v-col cols="12" md="12">
                      <v-text-field
                        v-model="email_subject"
                        :rules="[(v) => !!v || 'This field is required']"
                        label="Email Subject"
                        required
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="campaignMode == 'email' || campaignMode == 'both'"
                  >
                    <v-col cols="12" md="12">
                      <v-textarea
                        v-model="email_intro"
                        label="Email Intro"
                        outlined
                        dense
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="campaignMode == 'email' || campaignMode == 'both'"
                  >
                    <v-col cols="12" md="12">
                      <label style="margin-right: 100%">Email Body</label>
                      <vue-editor
                        v-model="email"
                        use-custom-image-handler
                        @image-added="handleImageAdded"
                      >
                      </vue-editor>
                    </v-col>
                  </v-row>
                  <v-row v-if="campaignMode == 'sms' || campaignMode == 'both'">
                    <v-col cols="12" md="12">
                      <v-text-field
                        v-model="sms_title"
                        :rules="[(v) => !!v || 'This field is required']"
                        label="SMS Title"
                        required
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="campaignMode == 'sms' || campaignMode == 'both'">
                    <v-col cols="12" md="12">
                      <v-textarea
                        v-model="sms"
                        :rules="[(v) => !!v || 'This field is required']"
                        label="SMS Text"
                        required
                        outlined
                        dense
                      ></v-textarea>
                    </v-col>
                  </v-row>

                  <v-row class="buttonbox">
                    <v-btn class="campaign-btn" @click="submit"> Save </v-btn>
                    <v-btn class="campaign-btn-clear" @click="back">
                      Cancel
                    </v-btn>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { VueEditor } from "vue2-editor";
import axios from "axios";

export default {
  mixins: [validationMixin],
  validations: {
    campaignType: { required },
    campaignTopic: { required },
    campaignMode: { required },
    frequency: { required },
    user_type: { required },
    start_date: {
      required,
      // minValue: value => value <= new Date().toISOString()
    },
    end_date: {
      required,
      // minValue: value => value >= new Date().toISOString()
    },
    campaign_time: { required },
  },
  name: "Editor",
  components: {
    VueEditor,
  },

  data: () => ({
    startmenu: false,
    endmenu:false,
    start: "",
    end: "",
    email: "",
    sms: "",
    selected_days: "",
    in_app_title: "",
    sms_title: "",
    email_subject: "",
    valid: true,
    frequency: "",
    check: "",
    campaignTopic: "",
    user_type: "",
    userType: "",
    email_intro: "",
    campaignMode: "",
    campaignType: null,
    end_date: "",
    start_date: "",
    campaign_time: "",
    items: [],
    campaignTopics: [],
    campaignTypes: [],
    week_day: "",

    week_days: [
      { text: "MONDAY", value: "Monday" },
      { text: "TUESDAY", value: "Tuesday" },
      { text: "WEDNESDAY", value: "Wednesday" },
      { text: "THURSDAY", value: "Thursday" },
      { text: "FRIDAY", value: "Friday" },
      { text: "SATURDAY", value: "Saturday" },
      { text: "SUNDAY", value: "Sunday" },
    ],
    frequencies: [
      { text: "DAILY", value: "daily" },
      { text: "WEEKLY", value: "weekly" },
      { text: "MONTHLY", value: "monthly" },
      { text: "ALTERNATIVE", value: "Alternative" },
    ],

    campaignModes: [
      { text: "Email", value: "email" },
      { text: "SMS", value: "sms" },
      { text: "Both", value: "both" },
      { text: "In App", value: "in_app" },
    ],
    userType: [
      { text: "All Users", value: "All Users" },
      { text: "Free Trial Users", value: "Free Trial Users" },
      { text: "Paid Users", value: "Paid Users" },
      { text: "Registered Users", value: "Registered Users" },
    ],
  }),
  computed: {
    typeErrors() {
      const errors = [];
      if (!this.$v.campaignType.$dirty) return errors;
      !this.$v.campaignType.required && errors.push("Select Campaign Type");
      return errors;
    },
    topicErrors() {
      const errors = [];
      if (!this.$v.campaignTopic.$dirty) return errors;
      !this.$v.campaignTopic.required && errors.push("Select Campaign Topic");
      return errors;
    },
    modeErrors() {
      const errors = [];
      if (!this.$v.campaignMode.$dirty) return errors;
      !this.$v.campaignMode.required && errors.push("Select Campaign Mode");
      return errors;
    },
    frequencyErrors() {
      const errors = [];
      if (!this.$v.frequency.$dirty) return errors;
      !this.$v.frequency.required && errors.push("Select Frequency");
      return errors;
    },
    userErrors() {
      const errors = [];
      if (!this.$v.user_type.$dirty) return errors;
      !this.$v.user_type.required && errors.push("Select User Type");
      return errors;
    },
    start_dateErrors() {
      const errors = [];
      if (!this.$v.start_date.$dirty) return errors;
      !this.$v.start_date.required && errors.push("Select Campaign Start date");
      //  !this.$v.start_date.minValue &&
      // errors.push("Previous date are not allowed");
      return errors;
    },
    end_dateErrors() {
      const errors = [];
      if (!this.$v.end_date.$dirty) return errors;
     !this.$v.end_date.required && errors.push("Select Campaign End date");
      // !this.$v.end_date.minValue &&
      //   errors.push(" Selection of Previous date are not allowed ");
      return errors;
    },
    timeErrors() {
      const errors = [];
      if (!this.$v.campaign_time.$dirty) return errors;
      !this.$v.campaign_time.required && errors.push("Select Time");
      return errors;
    },
  },

  mounted() {
    let token = localStorage.getItem("token");
    axios
      .get(process.env.VUE_APP_ROOT_API + "admin/campaign-types", {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        this.campaignTypes = response.data;
        console.log();
      });
  },

  methods: {
    handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
      let token = localStorage.getItem("token");
      var formData = new FormData();
      formData.append("image", file);
      axios
        .post(process.env.VUE_APP_ROOT_API + "admin/upload-img", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          let url = response.data.filePath; // Get url from response
          Editor.insertEmbed(cursorLocation, "image", url);
          resetUploader();
        })
        .catch((err) => {
          alert("yukleme basarisiz! " + err);
        });
    },

    startDate(start_date) {
      this.$refs.menu.startDate(start_date);
    },

    endDate(end_date) {
      this.$refs.menu.endDate(end_date);
    },

    submit() {
      this.$v.$touch();
      let token = localStorage.getItem("token");
      let formdata = new FormData();
      formdata.append("campaign_mode", this.campaignMode);
      formdata.append("campaign_type_id", this.campaignType);
      formdata.append("campaign_topic_id", this.campaignTopic);
      formdata.append("frequency", this.frequency);
      formdata.append("selected_days", this.selected_days);
      formdata.append("week_day", this.week_day);
      formdata.append("in_app_title", this.in_app_title);
      formdata.append("campaign_start_date", this.start_date);
      formdata.append("campaign_end_date", this.end_date);
      formdata.append("campaign_time", this.campaign_time);
      formdata.append("email_subject", this.email_subject);
      formdata.append("email_intro", this.email_intro);
      formdata.append("email_text", this.email);
      formdata.append("sms_text", this.sms);
      formdata.append("sms_title", this.sms_title);
      formdata.append("user_type", this.user_type);

      axios
        .post(process.env.VUE_APP_ROOT_API + "admin/campaigns", formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          //  console.log(response)
          if (response.data.status == "success") {
            this.$router.push({ name: "AdminCampaign" }).catch(() => {});

            swal.fire({
              title: "Success!",
              text: "Record Added Successfully",
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#051d42",
              confirmButtonText: "OK",
            });
          } else {
            this.error_message = "Invalid username or password.";
          }
        });
    },

    onChangeData() {
      // $v.campaignType.$touch();
      let token = localStorage.getItem("token");
      axios
        .get(
          process.env.VUE_APP_ROOT_API +
            "admin/select-topics-by-type/" +
            this.campaignType,
          {
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        )
        .then((response) => {
          // console.log(response);
          this.campaignTopics = response.data;
          console.log(this.campaignTopics);
        });
    },
    back() {
      this.$router.push({ name: "AdminCampaign" }).catch(() => {});
    },
  },
};
</script>
<style></style>
